module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-02.7e30ed8d.png";